import { RDivider } from './RDivider';
import { resolveNoContainer } from './resolve-no-container';
import { resolveRendersOwnElement } from './resolve-renders-own-element';
import { defaultAttributeValues } from './default-attribute-values';
import { attributeEditModeConfigs } from './attribute-edit-mode-configs';
import type { DisplayCardEntry } from '@source-components-react/types';
import { ComponentIdentifiers } from '@source-components-react/component-identifiers';

export const displayCardEntry: DisplayCardEntry = {
  id: ComponentIdentifiers.rDivider,
  resolveNoContainer,
  resolveRendersOwnElement,
  card: ({ componentAttributes, styleProps, className }) => (
    <RDivider
      componentAttributes={componentAttributes}
      styleProps={styleProps}
      className={className}
    />
  ),
  defaultAttributeValues,
  attributeEditModeConfigs,
};
